/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Dots } from 'react-activity';
import es from 'date-fns/locale/es';
import moment from 'moment';

registerLocale('es', es);

class HeaderStatisticsComponet extends Component {
  onChangeInput = key => (e) => {
    if (this.props.onChange) {
      this.props.onChange(key, e);
    }
  }

  render() {
    const { title, hasToolbar, disable, onClickExport, onClickConsolte } = this.props;
    let { fromDate, toDate } = this.props;
    if (fromDate) {
      fromDate = moment(fromDate, 'DD-MM-YYYY').toDate();
    }
    if (toDate) {
      toDate = moment(toDate, 'DD-MM-YYYY').toDate();
    }
    return (
      <div className="section-header">
        <div className="section-title">
          <h2>{title}</h2>
        </div>
        {
          hasToolbar
            ? (
              <React.Fragment>
                <div className="section-toolbar">
                  <DatePicker
                    locale="es"
                    disabled={disable}
                    dateFormat="dd/MM/yyyy"
                    name="dateToExportStart"
                    placeholderText="Desde"
                    // maxDate={toDate}
                    maxDate={new Date()}
                    selected={fromDate}
                    onChange={this.onChangeInput('fromDate')}
                  />
                  <DatePicker
                    locale="es"
                    disabled={disable}
                    dateFormat="dd/MM/yyyy"
                    name="dateToExportFinish"
                    placeholderText="Hasta"
                    // minDate={fromDate}
                    maxDate={new Date()}
                    selected={toDate}
                    onChange={this.onChangeInput('toDate')}
                  />
                  <button
                    className="button-dark"
                    type="button"
                    disabled={this.props.loadingData.loading || disable} onClick={onClickConsolte}>
                    {disable ? <Dots /> : 'Consultar'}
                  </button>
                  <button
                    className="button-dark"
                    type="button"
                    disabled={this.props.loadingData.loading || disable}
                    onClick={onClickExport}>
                    Exportar
                  </button>
                </div>
              </React.Fragment>
            )
            : null
        }
      </div>
    );
  }
}

export default HeaderStatisticsComponet;
